<template>
  <!--
    The "Perks used" chart (PerksChart.vue) and the "Latest perks used" table were removed
    for now because the production data behind them is not ready. PerksChart.vue is still on
    disk and the table markup is in git history, so both can be restored when the data lands.
    Until then "Perks inventory" is the only card, so it runs full width.
  -->
  <div class="flex flex-col gap-4 md:gap-6">
    <Card>
      <CardHeader>
        <CardTitle>Perks inventory</CardTitle>
        <CardDescription>Voucher stock across your perks</CardDescription>
        <CardAction>
          <Button variant="outline" size="sm" @click="$router.push('/perks-and-rewards/inventory')">
            View all
          </Button>
        </CardAction>
      </CardHeader>
      <CardContent>
        <DataTable
          :headers="inventoryHeaders"
          :items="inventory"
          :loading="loadingInventory"
          :error="inventoryError"
          hide-footer
          @retry="fetchInventory"
        >
          <template #item-productName="{ productName }">
            <span class="text-sm whitespace-nowrap">{{ productName || '—' }}</span>
          </template>
        </DataTable>
      </CardContent>
    </Card>
  </div>
</template>

<script>
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardAction,
  Button,
  DataTable,
} from '@boogi/ui'

export default {
  name: 'PerksTab',
  components: {
    Card,
    CardHeader,
    CardTitle,
    CardDescription,
    CardContent,
    CardAction,
    Button,
    DataTable,
  },
  data() {
    return {
      inventory: [],
      loadingInventory: true,
      inventoryError: false,
      inventoryHeaders: [
        { text: 'Perk', value: 'productName' },
        { text: 'Purchased', value: 'totalPurchased' },
        { text: 'Assigned', value: 'redeemed' },
        { text: 'Used', value: 'unlocked' },
        { text: 'Remaining', value: 'remaining' },
      ],
    }
  },
  created() {
    this.fetchInventory()
  },
  methods: {
    apiBase() {
      return localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL
    },
    authHeaders() {
      return {
        'Content-Type': 'application/json',
        Authorization: `${localStorage.getItem('token')}`,
      }
    },
    async fetchInventory() {
      this.loadingInventory = true
      this.inventoryError = false
      try {
        const res = await this.$apiFetch(
          `${this.apiBase()}/private/api/client/product-inventory?page=0&size=8`,
          { method: 'GET', headers: this.authHeaders() }
        )
        if (res.ok) {
          this.inventory = (await res.json()).content || []
        } else {
          this.inventoryError = true
        }
      } catch (e) {
        this.inventoryError = true
      } finally {
        this.loadingInventory = false
      }
    },
  },
}
</script>
